import { useState, useEffect } from 'react'

interface DateOfBirthInputProps {
  value: string // ISO date string (YYYY-MM-DD)
  onChange: (date: string) => void
  error?: string
}

export function DateOfBirthInput({ value, onChange, error }: DateOfBirthInputProps) {
  const [day, setDay] = useState<string>('')
  const [month, setMonth] = useState<string>('')
  const [year, setYear] = useState<string>('')

  const months = [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ]

  const currentYear = new Date().getFullYear()
  const years = Array.from({ length: currentYear - 1920 + 1 }, (_, i) => currentYear - i)

  const days = Array.from({ length: 31 }, (_, i) => {
    const dayNum = i + 1
    return dayNum < 10 ? `0${dayNum}` : `${dayNum}`
  })

  // Initialize from value prop
  useEffect(() => {
    if (value) {
      const parts = value.split('-')
      if (parts.length === 3) {
        setYear(parts[0])
        setMonth(parts[1])
        setDay(parts[2])
      }
    }
  }, [value])

  // Update parent when any field changes
  useEffect(() => {
    if (day && month && year) {
      const dateString = `${year}-${month}-${day}`
      onChange(dateString)
    }
  }, [day, month, year, onChange])

  const selectClass = `w-full px-3 text-sm border rounded-lg h-[44px] focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition bg-white ${
    error ? 'border-red-500 bg-red-50' : 'border-gray-300'
  }`

  return (
    <div className="space-y-1.5">
      <div className="flex gap-3">
        <div className="w-24 flex-shrink-0">
          <label className="block text-sm font-medium text-gray-700 mb-1">Day</label>
          <select value={day} onChange={(e) => setDay(e.target.value)} className={selectClass}>
            <option value="">Day</option>
            {days.map((d) => (
              <option key={d} value={d}>{parseInt(d)}</option>
            ))}
          </select>
        </div>

        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">Month</label>
          <select value={month} onChange={(e) => setMonth(e.target.value)} className={selectClass}>
            <option value="">Month</option>
            {months.map((m) => (
              <option key={m.value} value={m.value}>{m.label}</option>
            ))}
          </select>
        </div>

        <div className="w-28 flex-shrink-0">
          <label className="block text-sm font-medium text-gray-700 mb-1">Year</label>
          <select value={year} onChange={(e) => setYear(e.target.value)} className={selectClass}>
            <option value="">Year</option>
            {years.map((y) => (
              <option key={y} value={y}>{y}</option>
            ))}
          </select>
        </div>
      </div>
      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  )
}
